<div class="newsletter-bubble">
  <div
    [ngClass]="{ 'newsletter-bubble__content-above': market !== 'de' && market !== 'nl' && market !== 'fr' }"
    class="newsletter-bubble__content"
  >
    <span class="newsletter-bubble__content__bubble-discount"
      >{{ amount || NLDiscount }}{{ (voucherType === PERCENTAGE || !voucherType) ? '%' : '€' }}*</span
    >
  </div>
  <div
    [ngClass]="{ 'newsletter-bubble__content-below': market !== 'de' && market !== 'nl' && market !== 'fr' }"
    class="newsletter-bubble__content"
  >
    <span *ngIf="market !== 'nl'" class="newsletter-bubble__content__bubble-text">{{
      'HOME.HOME_PAGE.NEWSLETTER_BUBBLE.TITLE' | translate
    }}</span>
    <span class="newsletter-bubble__content__bubble-text" *ngIf="voucherType !== PERCENTAGE">{{
      'HOME.HOME_PAGE.NEWSLETTER_BUBBLE.SUBTITLE' | translate
    }}</span>
    <span class="newsletter-bubble__content__bubble-text" *ngIf="voucherType === PERCENTAGE">{{
      'HOME.HOME_PAGE.NEWSLETTER_BUBBLE.SUBTITLE.PERCENTAGE' | translate
    }}</span>
  </div>
</div>
